export const MESSAGE = "MESSAGE";
